export default "__VITE_ASSET__rI9nvGlA__"